import { myFetch } from './fetch-config'

const scannerApi = '/scanner'

export interface ScannerTokenItem {
  address: string
  symbol: string
  name?: string
  deploy_time?: string | number
  [key: string]: unknown
}

export interface GetTokensResponse {
  code: number
  data?: {
    tokens: ScannerTokenItem[]
    total: number
  }
}

/**
 * 查询 ERC20 Token 列表（与 new-explorer scanner 接口一致）
 */
export function getTokens(
  page = 1,
  size = 20,
  symbol = '',
  address = ''
): Promise<GetTokensResponse> {
  const sym = encodeURIComponent(symbol == null ? '' : String(symbol))
  let url = `${scannerApi}/evmapi/tokens?page=${page}&size=${size}&symbol=${sym}`
  if (address) {
    url += `&address=${encodeURIComponent(address)}`
  }
  return myFetch(url, {}, { method: 'GET' })
}

export interface TokenDetailApiData {
  address: string
  symbol: string
  name?: string
  decimals?: number
  total_supply?: string | number
  total_supply_formatted?: string | number
  deploy_time?: string | number
  deploy_block_number?: number
  deploy_tx_hash?: string
  deployer?: string
  type?: string
  verification_status?: string
  holders?: number
  [key: string]: unknown
}

export interface GetTokenDetailResponse {
  code: number
  message?: string
  data?: TokenDetailApiData
}

export function getTokenDetail(
  address: string
): Promise<GetTokenDetailResponse> {
  const enc = encodeURIComponent(address)
  const url = `${scannerApi}/evmapi/tokens/${enc}`
  return myFetch(url, {}, { method: 'GET' })
}

export interface TokenTransferItem {
  tx_hash: string
  from: string
  to: string
  block_time?: string | number
  block_number?: number
  value?: string | number
  value_formatted?: string | number
  token_symbol?: string
  token_decimals?: number
  [key: string]: unknown
}

export interface GetTokenTransfersResponse {
  code: number
  message?: string
  data?: {
    transfers: TokenTransferItem[]
    total: number
  }
}

export function getTokenTransfers(
  address: string,
  params: { page?: number; size?: number; from?: string; to?: string } = {}
): Promise<GetTokenTransfersResponse> {
  const { page = 1, size = 20, from, to } = params
  const enc = encodeURIComponent(address)
  let url = `${scannerApi}/evmapi/tokens/${enc}/transfers?page=${page}&size=${size}`
  if (from) url += `&from=${encodeURIComponent(from)}`
  if (to) url += `&to=${encodeURIComponent(to)}`
  return myFetch(url, {}, { method: 'GET' })
}

export interface Erc20BalanceRow {
  symbol: string
  name?: string
  balance_formatted?: number
  [key: string]: unknown
}

export interface GetAccountErc20BalancesResponse {
  code: number
  message?: string
  data?: {
    tokens: Erc20BalanceRow[]
  }
}

/** 按地址查 ERC20 持仓（与 new-explorer scanner 一致） */
export function getAccountERC20Balances(
  address: string,
  params: { page?: number; size?: number; min_balance?: number | string } = {}
): Promise<GetAccountErc20BalancesResponse> {
  const { page = 1, size = 20, min_balance = 0.001 } = params
  const enc = encodeURIComponent(address)
  let url = `${scannerApi}/evmapi/accounts/${enc}/erc20-balances?page=${page}&size=${size}`
  if (min_balance !== '' && min_balance !== undefined && min_balance !== null) {
    url += `&min_balance=${encodeURIComponent(String(min_balance))}`
  }
  return myFetch(url, {}, { method: 'GET' })
}

// ========== 交易解析 (ERC20 转账记录) ==========

export interface Erc20EventArgs {
  from?: string
  to?: string
  value?: number | string
  token_symbol?: string
  token_decimals?: number
  [key: string]: unknown
}

export interface Erc20EventItem {
  EventIndex?: number
  Args?: Erc20EventArgs
  [key: string]: unknown
}

export interface TransactionAnalysisData {
  Events?: Erc20EventItem[]
  [key: string]: unknown
}

export interface GetTransactionAnalysisResponse {
  code: number
  message?: string
  data?: TransactionAnalysisData
}

/** 交易解析 - 获取单笔EVM交易的ERC20转账记录 */
export function getTransactionAnalysis(
  txHash: string
): Promise<GetTransactionAnalysisResponse> {
  const enc = encodeURIComponent(txHash)
  const url = `${scannerApi}/evmapi/transactions/${enc}/analysis`
  return myFetch(url, {}, { method: 'GET' })
}
